export default {
    title: "Invoices",
    my_invoices: "My Invoices",
    filter_by_date: "Filter by date",
    status_label: "Status",
    status_pending: "Pending Payment",
    status_overdue: "Overdue",
    status_paid: "Paid",
    status_cancelled: "Cancelled",
    status_draft: "Draft",
    status_overdue_label: "Overdue",
    issue_date: "Issue Date",
    due_date: "Due Date",
    payment_date: "Payment Date",
    total_amount: "Total Amount",
    actions: "Actions",
    export: "Export",
    add_charge: "Add Charge",
    add_charge_subtitle: "Create extra negotiations with installments",
    generate_monthly: "Generate Monthly Invoices",
    generate_monthly_title: "Generate monthly invoices",
    generate_monthly_subtitle: "Review what will be deleted and generated before confirming.",
    generation_places: "Places",
    generation_to_generate: "To generate",
    generation_drafts_to_delete: "Drafts to delete",
    generation_blocked: "Kept",
    generation_without_plan: "No plan",
    generation_selected: "{selected} of {total} selected",
    generation_select_all: "Select all",
    generation_deselect_all: "Deselect all",
    generation_main_target: "Main place",
    generation_main_badge: "Main",
    generation_running: "Generating monthly invoices...",
    generation_failed_places: "{count} place(s) could not be processed.",
    generation_without_plan_title: "Active establishments without a plan",
    generation_without_plan_hint: "These establishments will not have monthly invoices generated until a plan is linked.",
    generation_no_changes: "No monthly invoices need to be generated for the current plan cycles.",
    generation_confirm: "Generate invoices",
    generation_preview_error: "Could not load the monthly invoice generation preview.",
    generation_execute_error: "Could not generate monthly invoices.",
    generation_success: "Generated {generated} invoice(s) and deleted {deleted} draft invoice(s).",
    generation_partial_success: "Generated {generated} invoice(s) and deleted {deleted} draft invoice(s), but {failed} place(s) or {syncErrors} sync issue(s) need review.",
    establishment: "Establishment",
    branch: "Branch",
    paid_label: "Paid:",
    pay_now: "Pay now",
    pay: "Pay",
    invoice: "Invoice",
    delete_invoice: "Delete Invoice",
    delete_confirmation: "Are you sure you want to delete this invoice? This action cannot be undone.",
    cancel: "Cancel",
    yes_delete: "Yes, delete",
    attached_bank_slip: "Attached Bank Slip",
    available_for_download: "Available for download",
    wait_a_moment: "Wait a moment",
    drag_pdf_here: "Drag your PDF here",
    or_click_to_select: "or click the button below to select",
    description: "Description",
    add_extra_cost: "Add extra cost",
    invoice_total: "Invoice Total",
    total_paid: "Total Paid",
    error_loading: "Error loading invoice",
    bank_slip_available: "Bank Slip available",
    click_to_open_bank_slip: "Click to open the bank slip in a new tab.",
    add_charge_hint: "Amount charged on each installment. The contract total is this amount multiplied by the number of installments.",
    not_informed: "Not informed",
    view_details: "View Details",
    loading_details: "Loading invoice details...",
    load_error_not_found: "Invoice not found or access denied.",
    load_error_general: "An error occurred while loading the invoice. Please try again.",
    update_success: "Invoice updated successfully!",
    view_bank_slip: "View bank slip",
    bank_slip_unavailable_msg: "Bank slip is not yet available. Please contact support.",
    details_back: "Back",
    delete_only_draft_error: "Only draft invoices can be deleted.",
    delete_success: "Invoice deleted successfully.",
    delete_confirm_title: "Delete Invoice",
    filter_status: "Status",
    filter_establishment: "Establishment",
    n_invoices: "{count} invoices",
    cost_breakdown: "Cost Breakdown",
    comparing_with: "Comparing with:",
    remove_comparison: "Remove comparison",
    compare: "Compare",
    no_other_monthly_invoices: "No other monthly invoices available",
    loading_invoices: "Loading invoices...",
    select_invoice: "Select invoice...",
    quantity: "Quantity",
    value: "Value",
    total: "Total",
    no_detailed_costs_found: "No detailed costs found on this invoice.",
    no_invoices_found: "No invoices found",
    no_invoices_subtitle: "There are no invoices in the selected period. Try changing the date filter.",
    subtotal: "Subtotal",
    interest_fines: "Fines and Interest",
    discount_label: "Discount",
    comparison_only_monthly_error: "Comparison is supported only for monthly invoices.",
    item_base_plan: "Base Plan",
    item_contacts: "Contacts",
    item_extra_users: "Extra Users",
    item_extra_branches: "Extra Branches",
    item_users: "Users",
    item_branches: "Branches",
    active: "active",
    included: "included",
    extra: "extra",
    tooltip_active_users: "Active users",
    tooltip_included_users: "Users included in the plan",
    tooltip_extra_users: "Extra users charged on the invoice",
    tooltip_active_branches: "Active branches",
    tooltip_included_branches: "Branches included in the plan",
    tooltip_extra_branches: "Extra branches charged on the invoice",
    item_integrations: "Senders",
    item_credits: "Credits",
    item_extra_credits: "Extra Credits",
    item_incentivized_sales_fee: "Incentivized Sales Fee",
    item_retention_fee: "Retention Fee",
    item_cost_adjustment: "Cost Adjustment",
    item_extra_charge: "Extra Charge",
    back_to_invoices: "Back to Invoices",
    edit_invoice: "Edit Invoice",
    save_changes: "Save Changes",
    establishment_name: "Establishment name",
    cnpj: "Tax ID",
    phone: "Phone",
    email: "Email",
    address: "Address",
    complement_short: "Compl.",
    neighborhood: "Neighborhood",
    city: "City",
    state_short: "State",
    zip_code_short: "Zip Code",
    invoice_title: "Invoice title",
    period_label: "Period:",
    issue_date_label: "Issue Date:",
    due_date_label: "Due Date:",
    attach_bank_slip: "Attach Bank Slip",
    internal_notes: "Internal Notes",
    internal_notes_placeholder: "Add internal notes about this invoice...",
    internal_notes_hint: "These notes are visible only to the internal team.",
    save_notes: "Save Notes",
    notes_saved_success: "Notes saved successfully!",
    save_notes_error: "Error saving internal notes.",
    slip_compensation_hint: "Payments via bank slip can take up to 3 business days to be cleared.",
    change_status_to: "Change status to {label}",
    change_status_subtitle: "You are changing the status of: {invLabel}. Confirm only if this change is intentional.",
    change_status_confirm: "Are you sure you want to change the status of this invoice to \"{label}\"? This action may impact the client and financial records.",
    yes_change: "Yes, change",
    wait_payment_title: "Wait for invoice payment",
    wait_payment_subtitle: "{invLabel} — the status will change to \"Awaiting payment\".",
    check_bank_slip_hint: "Confirm the bank slip is correct before changing the status.",
    yes_change_status: "Yes, change status",
    will_be_cancelled_subtitle: "{invLabel} will be marked as cancelled.",
    cancel_invoice_hint: "Cancelled invoices usually leave the active collection flow. Confirm with finance before proceeding.",
    yes_cancel_invoice: "Yes, cancel invoice",
    will_be_paid_subtitle: "{invLabel} will be marked as paid.",
    mark_as_paid_hint: "Use this option only when the payment has actually been received and checked.",
    yes_mark_as_paid: "Yes, mark as paid",
    attach_bank_slip_error: "To set to 'Awaiting Payment', you must first attach the invoice bank slip.",
    update_status_error: "Error updating status.",
    update_status_connection_error: "Connection failure while updating status.",
    update_error: "Error saving changes.",
    update_connection_error: "Connection failure while saving.",
    delete_error: "Error deleting invoice.",
    delete_connection_error: "Connection failure while deleting the invoice.",
    confirm: "Confirm",
    general: "General",
    remove: "Remove",
    loading: "Loading...",
    // Bank Slip Management
    invoice_bank_slip: "Invoice Bank Slip",
    sending_document: "Sending document...",
    select_file: "Select File",
    upload_bank_slip_hint: "Upload the bank slip in PDF format (maximum 5MB).",
    view_pdf: "View PDF",
    view: "View",
    remove_file: "Remove file",
    remove_bank_slip_title: "Remove Bank Slip",
    remove_bank_slip_confirm: "Are you sure you want to remove the bank slip from this invoice?",
    yes_remove: "Yes, remove",
    only_pdf_error: "Only PDF files are accepted.",
    max_size_error: "The file must be at most 5MB.",
    upload_failure: "Failed to upload the bank slip.",
    upload_connection_error: "Connection failure while uploading the bank slip.",
    remove_failure: "Failed to remove the bank slip.",
    remove_connection_error: "Connection failure while removing the bank slip.",
    // Add Charge Form
    select_establishment: "Select an establishment",
    total_extra_value: "Installment amount",
    installments: "Installments",
    first_due_date_label: "First due date",
    select_date: "Select a date",
    describe_negotiation: "Describe the negotiation...",
    installments_preview: "Installments preview",
    installment: "Installment",
    installments_sum: "Sum of installments",
    creating_invoices: "Creating invoices...",
    create_n_invoices: "Create {n} invoices",
    create_one_invoice: "Create invoice",
    charge_created_success: "{count} invoice(s) created successfully!",
    create_charge_error: "Error creating charge.",
    connection_failure: "Connection failure.",
    // Actions Menu
    cancel_invoice: "Cancel Invoice",
    delete_only_draft_hint: "Only draft invoices can be deleted",
    mark_as_paid: "Mark as Paid",
    no_changes_to_save: "No changes to save.",
    generate_bank_slip: "Generate Bank Slip",
    bank_slip_generating: "Generating bank slip...",
    bank_slip_generated_title: "Bank slip generated successfully",
    bank_slip_generated_hint: "Payment may take up to 3 business days to be confirmed.",
    bank_slip_view_voucher: "Open bank slip page",
    bank_slip_copy_code: "Copy payment code",
    bank_slip_code_copied: "Payment code copied!",
    bank_slip_expires_at: "Expires on",
    bank_slip_generation_error: "Could not generate bank slip. Please try again.",
    bank_slip_missing_tax_id: "CPF/CNPJ not set on this invoice. Update billing details before generating a bank slip.",
    bank_slip_missing_cep: "Postal Code (CEP) not set on this invoice. Update billing details before generating a bank slip.",
    bank_slip_generation_success: "Bank slip generated successfully!",
    bank_slip_generated_email_sent: "Bank slip generated and e-mail sent to the billing contact.",
    send_invoice_email: "Send by e-mail",
    invoice_email_sent: "Invoice e-mail sent to the billing contact.",
    invoice_email_failed: "Could not send the invoice e-mail.",
    missing_tax_id_error: "Establishment Tax ID is missing. Update the billing details before generating a bank slip.",
    missing_email_error: "Establishment email is missing. Update the billing details before generating a bank slip.",
    missing_cep_error: "Establishment Postal Code (CEP) is missing. Update the billing details before generating a bank slip.",
    minimum_amount_error: "The minimum amount to generate a bank slip is R$ 5.00.",
    gateway_slip_cancel_warning_title: "Warning: Gateway Cancellation",
    gateway_slip_cancel_warning_body: "This bank slip was generated automatically. Removing it will cancel the corresponding charge on the gateway, and the customer will no longer be able to pay it.",
    yes_cancel_and_remove: "Yes, cancel and remove",
    export: "Export",
    export_success: "Invoices exported successfully!",
    export_error: "Error exporting invoices.",
    invoice_payment_link: "Payment Link",
    payment_link_active_title: "Active Payment Link",
    payment_link_active_hint: "Customers can pay with credit card or digital wallets via Stripe.",
    payment_link_hint: "Generates a secure Stripe Checkout page for domestic and international credit cards.",
    generate_payment_link: "Generate Payment Link",
    payment_link_generating: "Generating Stripe link...",
    payment_link_generation_success: "Payment link generated successfully!",
    payment_link_generation_error: "Could not generate payment link. Please try again.",
    payment_link_copy: "Copy Link",
    payment_link_copied: "Link copied!",
    payment_link_view: "Open Checkout",
    payment_link_remove: "Remove Link",
    payment_link_remove_confirm_title: "Remove Payment Link",
    payment_link_remove_confirm_body: "Are you sure you want to remove this payment link? The Stripe session will expire and will no longer accept payments.",
    payment_link_remove_success: "Payment link removed successfully.",
    payment_link_remove_error: "Error removing payment link.",
    payment_link_expires_at: "Expires on",
    choose_payment_method: "Choose how you want to pay",
    choose_payment_method_subtitle: "Select one of the payment options available for this invoice:",
    pay_online_title: "Pay Online (Credit Card)",
    pay_online_desc: "Instant and secure payment via Stripe with credit card or digital wallets.",
    pay_online_btn: "Pay Online",
    pay_slip_title: "Bank Slip (Boleto)",
    pay_slip_desc: "View or print bank slip to complete payment.",
    badge_credit_card: "Credit Card",
    badge_instant: "Instant",
    badge_bank_slip: "Bank Slip",
    online_payment_available: "Online Payment Available",
    click_to_pay_online: "Click to pay with credit card or digital wallets via Stripe.",
    payment_unavailable_msg: "No payment option available for this invoice at this moment.",
    credits_whatsapp: "WhatsApp",
    credits_sms: "SMS",
    credits_rcs: "RCS",
    credits_email: "Email",
    credits_other: "Other",
    compare_difference: "Difference",
    compare_unchanged: "Unchanged",
    compare_changed_hint: "Highlighted rows changed compared with the reference invoice.",
    payment_correction_hint: "Correct interest, fines and the amount paid if it does not match what was received in the bank."
};
